<template>
  <div class="home">
    <div class="marathon-countdown" v-if="!hasMarathonStarted">
      <div class="container">
        <h2>{{ $root.marathon.name }} starts in...</h2>
        <Timer />
        <div class="start-date">{{ $root.marathon.starts }}</div>
      </div>
    </div>

    <div id="marathon_stream" v-if="$root.marathon.mode == `marathon`">
      <div class="container">
        <iframe
          src="https://player.twitch.tv/?channel=tombraidermarathon"
          frameborder="0"
          allowfullscreen="true"
          scrolling="no"
          height="480"
          width="70%"
        ></iframe>
        <iframe
          frameborder="0"
          scrolling="yes"
          height="480"
          width="29%"
          id="tombraidermarathon"
          src="https://www.twitch.tv/embed/tombraidermarathon/chat"
        ></iframe>
      </div>
    </div>

    <div class="marathon-info">
      <div class="container">
        <div class="hero has-text-centered">
          <div class="hero-container">
            <h2>What is Tomb Raider Marathon?</h2>

            <p>
              Tomb Raider Marathon is a live stream gaming event where we play
              through many of the Tomb Raider games both casually and super
              quickly to raise money for charity. We have raised
              <b>$12,675.41‬</b> since April 2017.
            </p>

            <br />

            <p class="marathon-finished">
              Tomb Raider Marathon VII raised
              <b>$2,450.00</b>, which surpassed our goal of $1,500!
            </p>
            <br />

            <template v-if="$root.marathon.mode !== `post-marathon`">
              <h3>{{ $root.marathon.name }}</h3>

              <p>
                Join us on
                <b>{{ $root.marathon.starts }}</b
                >, for our seventh marathon, <b>{{ $root.marathon.name }}</b
                >! This time we'll be raising for
                <a :href="$root.marathon.charity_url" target="_blank">
                  <b>{{ $root.marathon.charity }}</b>
                </a>
              </p>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="marathon-video">
      <div class="container">
        <div class="hero has-text-centered">
          <div class="hero-container">
            <h2>Tomb Raider Marathon VII Collection</h2>
            <iframe
              :src="`${$root.marathon.latestVideo}&parent=${twitchEmbedParent}`"
              frameborder="0"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Timer from "@/components/global/Timer";

export default {
  components: { Timer },
  name: "home",
  filters: {
    localDateTime(dateString) {
      return moment(dateString).local();
    },
  },

  computed: {
    hasMarathonStarted() {
      const currentTime = Date.now() / 1000;
      return currentTime > this.$root.marathon.starts_unix;
    },

    twitchEmbedParent() {
      return location.hostname;
    },
  },
};
</script>

<style lang="scss">
#banner-hero {
  @media screen and (max-width: $phone-size) {
    display: none;
  }

  .hero-body {
    background: url("/static/images/splash-images/poster.png") no-repeat;
    background-position: center;
    position: relative;
  }
}

.marathon-countdown {
  border-bottom: 1px solid $default-border-col;
  clear: both;
  float: left;
  font-size: 2rem;
  font-weight: bold;
  padding: 10px 0;
  width: 100%;

  .container {
    align-items: center;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }

  h2 {
    margin-bottom: 20px;
    text-align: center;
    width: 100%;
  }

  .trm-timer {
    .trm-timer-val {
      clear: none;
      display: flex;
      float: left;
      flex-direction: column;
      flex-wrap: wrap;
      justify-content: center;
      width: auto;

      span {
        clear: both;
        display: inline-block;
        float: left;
        font-size: 1rem;
        text-align: center;
        width: auto;

        &:first-child {
          font-size: 1.5rem;
        }
      }

      &:not(:first-child) {
        margin-left: 20px;
      }
    }
  }

  .start-date {
    clear: both;
    display: inline-block;
    float: left;
    font-size: 1.2rem;
    margin-top: 20px;
    text-align: center;
    width: 100%;
  }
}

#marathon_stream {
  float: left;
  padding: 30px 0;
  width: 100%;
}

.marathon-info {
  background: url("/static/images/splash-images/what-is.jpg") no-repeat;
  background-position: center;
  background-size: cover;
  border-bottom: 1px solid $default-border-col;
  clear: both;
  color: $alt-fg-col;
  float: left;
  font-weight: bold;
  padding: 60px 0;
  width: 100%;

  h2 {
    font-size: 1.75rem;
    font-weight: bold;
    margin-bottom: 30px;
  }

  h3 {
    font-size: 1.25rem;
    font-weight: bold;
    margin-bottom: 15px;
  }

  p {
    font-weight: initial;

    a {
      &,
      &:link,
      &:visited {
        color: $marathon-col;

        &:hover {
          color: lighten($marathon-col, 10%);
        }
      }
    }
  }

  .hero {
    margin: 0 auto;
    max-width: 100%;
    width: 600px;

    @media screen and (max-width: $phone-size) {
      padding: 0 15px;
    }
  }
}

.marathon-video {
  clear: both;
  float: left;
  font-weight: bold;
  padding: 30px 0;
  width: 100%;

  h2 {
    font-size: 1.75rem;
    font-weight: bold;
    margin-bottom: 30px;
  }

  iframe {
    height: 360px;
    width: 640px;
  }

  @media screen and (max-width: $phone-size) {
    padding: 15px;

    iframe {
      height: 160px;
      width: 280px;
    }
  }
}

.marathon-finished {
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// index.vue?626dcdd8